export enum EMapLayer {
  tmdxServed = 'tmdxServed',
  countries = 'countries',
  lakes = 'lakes',
}
